import defaultState from '@/store/default';
export const state = defaultState;
